module.exports = __webpack_public_path__ + "img/userCard.5bea4146.png";